import { CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";

import { Model, StylesManager, settings } from "survey-core";
import { Survey } from "survey-react-ui";
import EvaluationSubsections from "../project/EvaluationSubsections";

import { defaultOptions1 } from "../../../config/loading-config.js";

import db from "../../../api/mongodb";
import Lottie from "react-lottie";

const PublicClientQuestionnaireComponent = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [surveyModel, setSurveyModel] = useState(new Model({}));
  const [surveySubmission, setSurveySubmission] = useState({});

  const [projectInfo, setProjectInfo] = useState({});

  const [error, setError] = useState("");

  const [surveyResult, setSurveyResult] = useState({});
  const [show, setShow] = useState(false);
  const [showFail, setShowFail] = useState(false);

  const [subsections, setSubsections] = useState([]);
  const [subsectionTitle, setSubsectionTitle] = useState("");

  const location = useLocation();
  const [lastSavedPage, setLastSavedPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [pageNo, setPageNo] = useState(null);

  const [openInformationPopup, setOpenInformationPopup] = useState(true);

  const tokenId = searchParams.get("token");

  useEffect(() => {
    if (surveyModel.pages.length > lastSavedPage) {
      surveyModel.currentPage = surveyModel.pages[lastSavedPage];
    }
  }, [surveyModel, lastSavedPage]);

  useEffect(() => {
    const apiCall = async () => {
      try {
        setIsLoading(true);
        var response = await db.get(
          `/api/public/getPublicClientQuestionnaire/${tokenId}`
        );
        setOpenInformationPopup(true)
        const survey = new Model(
          response.data.clientQuestionnaireTemplate.surveyTemplate
        );

        survey.onUpdateQuestionCssClasses.add(function (sender, options) {
          if (options.question.getType() === "file") {
            options.cssClasses.removeButtonBottom =
              options.cssClasses.removeButton;
          }
        });

        setSurveySubmission(response.data.clientQuestionnaireSubmission);
        const submission = response.data.clientQuestionnaireSubmission;

        if (submission.status === "modified") {
          survey.data = submission.answers;
          setSurveyResult(survey.data);
        }

        setLastSavedPage(submission.savedPageNo);
        setProjectInfo(response.data.project);
        setSurveyModel(survey);
        setIsLoading(false);
        setError("");
      } catch (error) {
        console.log(error);
        setError("Could not load the survey");
        setIsLoading(false);
      }
    };
    apiCall();
  }, []);

  const surveyValidateInput = (s, options) => {
    if (options.name === "image") {
      if (
        typeof options.value !== "undefined" &&
        typeof options.value[0] !== "undefined"
      ) {
        if (!options.value[0].type.includes("image")) {
          options.error = "Please upload an image";
        }
      }
    }
  };

  surveyModel.onComplete.add(async function (sender, options) {
    surveyModel.clear(false, false);
    setIsSaving(true);

    try {
      const curDate = new Date().toISOString();
      // const userid = sessionStorage.getItem("id")
      const body = {
        answers: sender.data,
        status: "modified",
        savedPageNo: surveyModel.currentPageNo,
        modifications: [
          ...surveySubmission.modifications,
          {
            date: curDate,
            apId: "Guest User",
          },
        ],
      };

      // setSurveyResult(survey.data);
      // setLastSavedPage(survey.currentPageNo);

      try {
        const putResponse = await db.put(
          `api/public/updatePublicClientQuestionnaire/${tokenId}`,
          body
        );
        setIsSaving(false);
        setShow(true);
        setTimeout(() => {
          setShow(false);
        }, 3000);
      } catch (error) {
        setIsSaving(false);
        setShowFail(true);
        setTimeout(() => {
          setShowFail(false);
        }, 5000);
      }
    } catch (error) {
      setIsSaving(false);
      setShowFail(true);
      setTimeout(() => {
        setShowFail(false);
      }, 3000);
    }
  });

  const scrollToPanel = (index) => {
    const allPanels = document.querySelectorAll(".sv-row .sv-row__panel");
    const surveyContainer = document.querySelectorAll(".survey-container");
    if (!allPanels[index]) return;
    const scrollPos = allPanels[index].offsetTop;
    surveyContainer[0].scrollTop = scrollPos;
  };

  surveyModel.onAfterRenderPage.add(function (sender, options) {
    const panels = options.page.elementsValue;

    var titles = [];
    panels.forEach((panel) => {
      titles.push(panel.title);
    });

    setSubsectionTitle(options.page.title);
    setSubsections(titles);
  });

  surveyModel.onAfterRenderPage.add(function (sender, options) {
    const panels = options.page.elementsValue;

    var titles = [];
    panels.forEach((panel) => {
      titles.push(panel.title);
    });

    setSubsectionTitle(options.page.title);
    setSubsections(titles);
  });

  if (error) {
    return (
      <div className="evaluation-header">
        <div className="header-info">
          <h1>Error </h1>
          <h1 className="eval-proj-title">{error} please try again later</h1>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <Lottie options={defaultOptions1} height={200} width={200} />;
  }

  return (
    <div>
      {show && (
        <div
          variant={"success"}
          style={{
            position: "fixed",
            top: "7rem",
            right: "1rem",
            width: "15%",
            textAlign: "center",
            border: "1px solid #badbcc",
            borderRadius: "0.375rem",
            backgroundColor: "#d1e7dd",
            color: "#0f5132",
            padding: 20,
            zIndex: `${show ? 1500 : 0}`,
          }}
        >
          Survey successfully saved!
        </div>
      )}
      {showFail && (
        <div
          variant="error"
          style={{
            position: "fixed",
            top: "7rem",
            right: "1rem",
            width: "15%",
            textAlign: "center",
            border: "1px solid #badbcc",
            borderRadius: "0.375rem",
            backgroundColor: "#fdeded",
            color: "#6c3231",
            padding: 20,
            zIndex: `${showFail ? 1500 : 0}`,
          }}
        >
          Survey could not be saved, maybe try reducing the amount of data and
          please try again
        </div>
      )}
      <Modal
        show={openInformationPopup}
        onHide={() => setOpenInformationPopup(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Typography variant="h6">Information</Typography>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="body1">
            Access to the client questionnaire via the provided link is granted
            for <b>7 days</b>. Kindly ensure to <b>save</b> your progress frequently. The
            security incident history section follows a cascading format. Users
            are prompted to report incidents within overarching categories (e.g.
            Acts against property only), subsequently specifying the nature of
            the incident (burglary, theft, etc.). Additional incidents can be
            added under each higher-level category, and comments can be added on
            the side.
          </Typography>
        </Modal.Body>
      </Modal>
      <div className="full-outer">
        <div className="evaluation-header">
          <div className="header-info">
            <h1>
              Client Questionnaire{" "}
              {isSaving && (
                <span style={{ fontSize: "15px", fontWeight: "normal" }}>
                  Saving... <CircularProgress size={20} />
                </span>
              )}{" "}
            </h1>
            <h1 className="eval-proj-title">
              {projectInfo.formData.projectName}
            </h1>
          </div>

          <div className="buttons-placement-header">
            <ButtonToolbar aria-label="eval-header">
              <Button
                className="survey-back-button"
                onClick={() => surveyModel.completeLastPage()}
                // onClick={() => saveSurveyResult(surveyResult)}
              >
                Save progress
              </Button>
            </ButtonToolbar>
          </div>
        </div>

        <div className="evaluation-sidebar">
          <div className="survey-sidebar-navigation">
            <div className="survey-navigation-title">
              {subsectionTitle} sections
            </div>
            <div className="survey-navigation-subsection" id="style-8">
              <EvaluationSubsections
                subsections={subsections}
                pageNo={pageNo}
                scrollFunction={scrollToPanel}
              />
            </div>
          </div>
        </div>

        <div className="survey-container">
          <Survey
            model={surveyModel}
            onValidateQuestion={surveyValidateInput}
          />
        </div>
      </div>
    </div>
  );
};

export default PublicClientQuestionnaireComponent;
